module.exports = __webpack_public_path__ + "static/media/document.60c4d61a.svg";